import "core-js/modules/es6.object.assign";
import RawPage from './Page';
import Header from './Header';
import Breadcrumb from './Breadcrumb';
import Content from './Content';
import Menu from './Menu';
/**
 * @public
 */

var Page = Object.assign(RawPage, {
  Header: Header,
  Breadcrumb: Breadcrumb,
  Content: Content,
  Menu: Menu
});
export default Page;
export { RawPage as Page, Breadcrumb, Header, Content, Menu };
export * from './Page';
export * from './Breadcrumb';
export * from './Header';
export * from './Content';
export * from './Menu';